import React from "react";
import { GeneralModal, useModalAlert } from "../GeneralComponents";

export function DobleAutenticacion({
  openModal,
  handleCloseModal,
  handleCloseModalForm,
  documentoSeleccionado,
  loadDocumentos,
  idProveedor
}) {
  const { showModalAlert } = useModalAlert();
  const [formData, setFormData] = React.useState({
    codigo: "",
  });
  const newModalField = [
    {
      type: "parrafo",
      label:
        "Se acaba de enviar un correo electrónico con un código de verificación de 6 dígitos",
    },
    { name: "codigo", label: "Código", type: "codigo" },
  ];

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  async function handleSaveDocument(formData) {
    
    try {
      let dataSend = {
        ...formData,
        id_proveedor: idProveedor,
      };
      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "doble-autenticacion/verificaOTP",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataSend),
        },
      );

      const result = await response.json();

      if (result.success) {
        showModalAlert("success", "Registrado correctamente ");
        handleCloseModal();
        handleCloseModalForm();
      } else {
        showModalAlert("danger", result.message);
      }
    } catch (error) {
      console.error("error....", error);
      showModalAlert("danger", "Error enviando el correo");
    }
  }

  return (
    <>
      <GeneralModal
        open={openModal}
        onClose={handleCloseModal}
        onFieldChange={handleFieldChange}
        fields={newModalField}
        formData={formData}
        setFormData={setFormData}
        enableDobleAutentication={true}
        onSave={handleSaveDocument}
        enableDocumentarytype={true}
        title={"Verificación en dos pasos"}
      />
    </>
  );
}
